"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UniverseBuilder = exports.EVENTS_THAT_REQUIRE_VALIDATION = void 0;
var item_1 = require("./models/item");
var payment_1 = require("./models/payment");
exports.EVENTS_THAT_REQUIRE_VALIDATION = [
    'ADD_ITEM',
    'ADD_ITEMS',
    'SET_MEMBERSHIP_DISCOUNT',
    'SET_ORDER_OFFER',
    'SET_PROMO_CODE',
    'UPDATE_USER',
    'CLEAR_PROMO_CODE',
    'CLEAR_CART',
];
/**
 * Shopping Cart Universe
 *
 * This is a singular shopping cart. Meaning each shopping cart is its own
 * universe. A shopping cart belongs to a venue but not always to a user (we need to support
 * anonymous / not logged in purchases)
 *
 * The basic flow is this:
 * 1. User requests a new shopping cart from backend
 * 2. User gets ID of new shopping cart and starts subscribing to messages for this cart
 * 3. User adds items to cart
 * 4. Backend verifies that the items in cart are actually valid
 * 5. We add a payment via Adyen
 * 6. Cart completed
 * 7. Order created and sent to user
 */
var UniverseBuilder = /** @class */ (function () {
    function UniverseBuilder() {
        // This is true when the backend has verified that the
        // contents of the shopping cart is actually something that we can buy
        this.isReadyForCheckout = false;
        // Which service type have we selected?
        this.serviceType = 'TAKE_AWAY';
        // Which venue ID does this shopping cart belong to?
        this.venueId = null;
        // Which user does this shopping cart belong to? Can be null
        this.userId = null;
        // When the cart is paid for, this gets set to the created order's ID
        this.orderId = null;
        // If the user has placed a comment on the order
        this.comment = null;
        // If user has a loyalty membership, this is how many points will be given out for the order
        this.pointsForCart = null;
        // If the user has applied an order offer
        this.offer = null;
        // True if we are ordering to a table without paying
        this.isPayLaterOrder = false;
        // If the user has entered a promo code
        this.promoCode = null;
        this.availableItemOffers = [];
        // The discount rate that the user gets by default from this membership
        this.membershipDiscountRate = 0;
        // When the user wants their order
        this.pickupTime = 'ASAP';
        // We use this to ensure that when we get a "consolidate order" event
        // it is not for an old version of our cart
        this.lastAddItemEventId = null;
        // If this order should be delivered somewhere, this field specifies
        // the ID of the node that contains delivery information.
        // This can be either a table ID, or a location ID or some other
        // future model that contains delivery data
        this.deliveryTargetId = null;
        // If we are ordering to an actual TSR cheque, or paying for a
        // cheque, this will be set to its ID.
        this.chequeId = null;
        // If we are paying with cashback, this is how much we intend to
        // pay with cashback
        this.cashbackPaymentAmount = 0;
        this.payments = [];
        this.items = [];
        // The amount of money that we have received confirmation for in the frontend
        // but not yet in the backend
        this.unverifiedPaymentAmount = 0;
        // These events will be automatically removed if the client tries to send them
        this.backendOnlyEvents = ['VERIFY_ORDER', 'CONSOLIDATE_ORDER'];
        // If an error occurred in the backend
        this.error = null;
    }
    /**
     * Add an event to the universe. This updates our local state.
     *
     * @param event The event to add
     */
    UniverseBuilder.prototype.addEvent = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var _youMissedAddingTheEventToTheSwitch;
            var _this = this;
            return __generator(this, function (_a) {
                if (exports.EVENTS_THAT_REQUIRE_VALIDATION.includes(event.type)) {
                    // Let the backend know that we would like to get our new items array verified
                    // We use this to ensure we only react to the most recent event in the backend
                    this.lastAddItemEventId = event.eventId;
                    this.isReadyForCheckout = false;
                }
                switch (event.type) {
                    case 'CREATE_CART':
                        this.venueId = event.venueId;
                        this.userId = event.userId;
                        this.deliveryTargetId = event.deliveryTargetId;
                        this.serviceType = event.serviceType;
                        break;
                    case 'ADD_ITEM':
                        this.items = item_1.default.add(this.items, __assign(__assign({}, event.item), { createdAt: event.createdAt }));
                        this.items = item_1.default.recalculateDiscounts(this.items, this.availableItemOffers, this.offer, this.promoCode, this.membershipDiscountRate);
                        this.cashbackPaymentAmount = 0;
                        break;
                    case 'ADD_ITEMS':
                        event.items.forEach(function (item) {
                            _this.items = item_1.default.add(_this.items, __assign(__assign({}, item), { createdAt: event.createdAt }));
                        });
                        this.items = item_1.default.recalculateDiscounts(this.items, this.availableItemOffers, this.offer, this.promoCode, this.membershipDiscountRate);
                        this.cashbackPaymentAmount = 0;
                        break;
                    case 'REMOVE_ITEM':
                        this.items = item_1.default.remove(this.items, event.id);
                        this.cashbackPaymentAmount = 0;
                        break;
                    case 'CLEAR_CART':
                        this.items = [];
                        this.offer = null;
                        this.cashbackPaymentAmount = 0;
                        break;
                    case 'ADD_PAYMENT':
                        this.payments = payment_1.default.add(this.payments, {
                            amount: event.amount,
                            id: event.id,
                            tip: event.tip,
                            type: event.paymentType,
                            createdAt: event.createdAt,
                            transactionId: event.transactionId,
                        });
                        // This event is a payment verification, so reduce the amount of unverified payments
                        this.unverifiedPaymentAmount -= event.amount;
                        break;
                    case 'ADD_CLIENT_SIDE_PAYMENT':
                        // This event can be created by the frontend, so its only for having a sanity check
                        // that we dont leave any payments hanging
                        this.unverifiedPaymentAmount += event.amount;
                        break;
                    // This event is only allowed from the backend
                    case 'CONSOLIDATE_ORDER':
                        if (event.lastAddItemEventId !== this.lastAddItemEventId) {
                            return [2 /*return*/];
                        }
                        this.items = event.items;
                        this.isReadyForCheckout = true;
                        break;
                    case 'SET_DELIVERY_TARGET_ID':
                        this.deliveryTargetId = event.id;
                        break;
                    case 'SET_CASHBACK_PAYMENT_AMOUNT':
                        this.cashbackPaymentAmount = event.amount;
                        break;
                    case 'SET_COMMENT':
                        this.comment = event.comment;
                        break;
                    case 'CLEAR_ORDER_OFFER':
                        this.offer = null;
                        break;
                    case 'SET_ORDER_OFFER':
                        this.offer = event.id
                            ? {
                                id: event.id,
                                title: event.title,
                                discountRate: event.discountRate,
                                discountType: event.discountType,
                            }
                            : null;
                        // Clear promo code if we're using an offer.
                        this.promoCode = null;
                        this.items = item_1.default.recalculateDiscounts(this.items, this.availableItemOffers, this.offer, this.promoCode, this.membershipDiscountRate);
                        break;
                    case 'SET_PROMO_CODE':
                        this.promoCode = event.id
                            ? {
                                id: event.id,
                                code: event.code,
                                discountRate: event.discountRate,
                                discountType: event.discountType,
                                offerType: event.offerType,
                                title: event.title,
                            }
                            : null;
                        // Clear this.offer if we're using a promocode.
                        this.offer = null;
                        this.items = item_1.default.recalculateDiscounts(this.items, this.availableItemOffers, this.offer, this.promoCode, this.membershipDiscountRate);
                        break;
                    case 'CLEAR_PROMO_CODE':
                        this.promoCode = null;
                        this.offer = null;
                        this.items = item_1.default.recalculateDiscounts(this.items, this.availableItemOffers, this.offer, this.promoCode, this.membershipDiscountRate);
                        break;
                    case 'SET_MEMBERSHIP_DISCOUNT':
                        this.membershipDiscountRate = event.discountRate;
                        this.items = item_1.default.recalculateDiscounts(this.items, this.availableItemOffers, this.offer, this.promoCode, this.membershipDiscountRate);
                        // The cart total price might change based on what membership discount we update the cart with.
                        break;
                    // This event is the practical end of the lifecycle of this cart
                    case 'ORDER_CREATED':
                        this.orderId = event.id;
                        break;
                    case 'SET_PICKUP_TIME':
                        this.pickupTime = event.time;
                        break;
                    case 'ERROR':
                        this.error = {
                            code: event.code,
                            message: event.message,
                            context: event.context,
                        };
                        break;
                    case 'MARK_AS_PAY_LATER_ORDER':
                        this.isPayLaterOrder = true;
                        break;
                    case 'CONNECT_TO_CHEQUE':
                        this.chequeId = event.id;
                        break;
                    case 'UPDATE_USER':
                        this.userId = event.id;
                        break;
                    case 'ADD_OFFER':
                        this.availableItemOffers = __spread(this.availableItemOffers, [
                            {
                                id: event.id,
                                stages: event.stages,
                                discountRate: event.discountRate,
                                discountType: event.discountType,
                                itemIds: event.itemIds,
                                offerType: event.offerType,
                                title: event.title,
                                tokenId: event.tokenId,
                            },
                        ]);
                        break;
                    default:
                        _youMissedAddingTheEventToTheSwitch = event;
                        // tslint:disable-next-line:no-unused-expression
                        _youMissedAddingTheEventToTheSwitch;
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * Compares payments and item amounts to see if the cart has been paid for
     *
     * @returns boolean True if we have paid for the whole cart
     */
    UniverseBuilder.prototype.isFullyPaid = function () {
        if (this.payments.length === 0) {
            return false;
        }
        if (this.items.length === 0) {
            return false;
        }
        // Adding a slight margin here to account for rounding issues. Sometimes 1.0 != 1.0.
        // Better safe than sorry
        return payment_1.default.sum(this.payments) >= item_1.default.sum(this.items) - 0.1;
    };
    UniverseBuilder.prototype.getTotalUnpaid = function () {
        return item_1.default.sum(this.items) - payment_1.default.sum(this.payments);
    };
    UniverseBuilder.prototype.getTotal = function () {
        return item_1.default.sum(this.items);
    };
    UniverseBuilder.prototype.serialize = function () {
        return {
            userId: this.userId,
            venueId: this.venueId,
            comment: this.comment,
            items: this.items,
            isReadyForCheckout: this.isReadyForCheckout,
            orderId: this.orderId,
            serviceType: this.serviceType,
            pointsForCart: this.pointsForCart,
            isFullyPaid: this.isFullyPaid(),
            pickupTime: this.pickupTime,
            deliveryTargetId: this.deliveryTargetId,
            lastAddItemEventId: this.lastAddItemEventId,
            availableItemOffers: this.availableItemOffers,
            isPayLaterOrder: this.isPayLaterOrder,
            offer: this.offer,
            promoCode: this.promoCode ? { code: this.promoCode.code, title: this.promoCode.title } : null,
            chequeId: this.chequeId,
            cashbackPaymentAmount: this.cashbackPaymentAmount,
            hasPendingPayment: this.unverifiedPaymentAmount > 0,
            total: this.getTotal(),
            totalDiscount: item_1.default.sumDiscounts(this.items),
            totalUnpaid: this.getTotalUnpaid(),
            vat: item_1.default.vatSum(this.items),
            subtotal: item_1.default.subtotalSum(this.items),
            error: this.error,
        };
    };
    return UniverseBuilder;
}());
exports.UniverseBuilder = UniverseBuilder;
